import { useState } from 'react';
import type { FaqItem } from '@/types/content';

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="flex items-start gap-3">
                  <span className="text-sm font-semibold text-primary-500 mt-0.5">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.question}
                  </span>
                </span>
                <i
                  className={`shrink-0 mt-1 text-foreground-500 transition-transform duration-300 ${
                    isOpen ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-6 pl-8 pr-6 text-sm md:text-[15px] leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}